import React from "react";
const FormLayoutSelection = ({ title, children }) => {
  return (
    <div className="row">
      <div className="col-lg-12 mb-lg-0 mb-4">
        <div className="card rounded-0 borderLine">
          {title && (
            <div className="card-header pb-0 rounded-0 bg-brand-primary cardHeaderBackground">
              <p className="crudTitle">{title}</p>
            </div>
          )}
          <div className="card-body p-3">
            <div className="row">
              <div className="container">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormLayoutSelection;